import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../sections/CheckinEntry";
import MaintenanceWorkflowForwardingCheckoutEntrySection from "../../../sections/CheckoutEntry";
import MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry from "../../../sections/DirectiveEntry/entries/ExecutionEntry";

const ExecutionEntryCompleted = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckoutEntrySection />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry
        showCompleted
        showFiscalAssessmentsDocuments
      />
    </>
  );
}

export default ExecutionEntryCompleted;
